
import React, { useRef, useState, useEffect } from "react";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Toolbar,
  Typography,
  IconButton,  
  Collapse,
  Popover,
} from "@mui/material";
import {
  ChevronLeft,
  ChevronRight,
  ExpandLess,
  ExpandMore,
  Inventory,
} from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./styles.module.css";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import Distribution from "../dashboard/Distribution";
import SettingsIcon from '@mui/icons-material/Settings';
import DescriptionIcon from '@mui/icons-material/Description';
import LocationOnIcon from '@mui/icons-material/LocationOn';
const drawerWidth = {
  xs: 230,
  sm: 230,
  md: 230,
  lg: 230,
  xl: 230,
};

const miniDrawerWidth = {
  md: 60,
  lg: 70,
  xl: 80,
};

const MiniMenuBar = ({
  mobileOpen,
  handleDrawerToggle,
  isDrawerOpen,
  handleDrawerWidthToggle,
}) => {
  const [openMenu, setOpenMenu] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [selected, setSelected] = useState("/dashboard");
  const navigate = useNavigate();
  const location = useLocation();

  const login_details = sessionStorage.getItem("loginUser");
  const userD = login_details ? JSON.parse(login_details) : null;

  if (!userD || !userD.result || !userD.result.userInfo) {
    navigate("/login");
    return null;
  }

  const userInfo = userD.result.userInfo;
  const name = userInfo.user_name;
  const role = userInfo.user_role;
  // const inside_plant = userInfo.inside_plant;
  // const assigned_depot_id = userInfo.assigned_depot_id;
  // const assigned_plant_id = userInfo.assigned_plant_id;
  const inside_plant = userInfo.inside_plant;
const assigned_depot_id = userInfo.assigned_depot_id;
const assigned_plant_id = userInfo.assigned_plant_id;
const depot_name = userInfo.depot_name || '';
const isInsidePlantDepot = inside_plant === 1 || depot_name === 'Karad Depot' || depot_name === 'Supa Depot';


  const handleMenuToggle = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  const handleMenuPopoverToggle = (event, menu) => {
    setAnchorEl(event.currentTarget);
    setSelectedMenu(menu);
  };


  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedMenu(null);
  };

  const handleSelect = (item, path) => {
    setSelected(item);
    navigate(path);
    handleMenuClose();
    if (handleDrawerToggle) {
      handleDrawerToggle();
    }
  };


  const getAllowedSubmenuItems = () => {
    const allSubmenuItems = {
      sales: ["AddCustomer", "CustomerPO", "Sales_Order","SOSummary", "ViewCyl_Stock"],
      Stores: [
  
        "AddSuppliers",
        "GRNEntry",
        "RMStock",
        "RMIssueEntry",

      ],
      Depot: [
        "CylinderInwardList",

        "ListEmptyDeliveryChallan",
        "DeliveryChallanList",
        "DriverActivityplanning",
        
      ],

      Production: [
        "CylinderInwardLists",
        "RMIssueEntry",

        "CylinderInspectionEntry",
        "newreceipt",
        "maintains",
        "ProductionEntry",
        "QualityControlEntry",
        "DeliveryChallans",
      ],
      logistics: [
        "Internal_Transfer_Entry",
        "DeliveryChallan",
        "Tempo_Loading",
        "EmptyCollection",
        "Cyl_Del_entry",
        "DeliveryEntry",
        "EmptyDeliveryChallan",
        "salesreturn"
      ],
      Report: [
        // "DepotWise",
        "emptycolllection",
        "qulityrport",
        "insepctionreport",
        "productionentry",
        "challanreport",
        //"emptycylinderholding",
        "EmptyCylinderInventory",
        "FinishedGoodInventory",
        "DailyDistributionReport",
        "CylinderUnderMaintenance",
        "Plant_Wise_Cylinder_Stock",
        "Cylinder_Wise_Cycle_Report",
        "mrreport",
        "productionquantityreport",
        "emptydeliverychllanreport",
        "deliveryacknowledgment",

      ],


      Utility: ["UOM_Conversion", "list-cpd"],
      MrReport: ["mrreport"],
      CustomerHolding: ["emptycylinderholding", "customerholdingsummary"],
      productionreport: ["productionentry"],
      Distribution: ["DailyDistributionReport"],
      Inventory: ["EmptyCylinderInventory"],

    };

    const { Report, ...allExceptReport } = allSubmenuItems;
    const { MrReport, ...allExceptMrReport } = allSubmenuItems;
     const { CustomerHolding, ...allExceptCustomerHolding } = allSubmenuItems;
    const { productionreport, ...allExceptproductionreport } = allSubmenuItems;
    const { Distribution, ...allExceptDistribution } = allSubmenuItems;
    const { Inventory, ...allExceptInventory } = allSubmenuItems;

    if (role.toLowerCase() === "admin") {
      const { Utility, Stores, ...allExceptReportUtilityStores } = allExceptReport;
      return allExceptReportUtilityStores;
    } else if (role.toLowerCase() === "production") {
      return { Production: allSubmenuItems.Production };
    } else if (role.toLowerCase() === "plant") {
      const base = { Production: allSubmenuItems.Production, Stores: allSubmenuItems.Stores };
      if (inside_plant === 1 || assigned_depot_id) {
        return { ...base, Depot: allSubmenuItems.Depot, logistics: allSubmenuItems.logistics };
      }
      return base;
    } else if (role.toLowerCase() === "depot") {
      const base = { Depot: allSubmenuItems.Depot, logistics: allSubmenuItems.logistics };
      if (inside_plant === 1 || assigned_plant_id) {
        return { ...base, Production: allSubmenuItems.Production, Stores: allSubmenuItems.Stores };
      }
      return base;
    } else if (role.toLowerCase() === "sales") {
      return { sales: allSubmenuItems.sales };
    } else if (role.toLowerCase() === "logistics") {
      return { logistics: allSubmenuItems.logistics };
    } else if (role.toLowerCase() === "stores") {
      return { Stores: allSubmenuItems.Stores };

    } else if (role.toLowerCase() === "management") {
      return {
        Report: allSubmenuItems.Report,
        logistics: allSubmenuItems.logistics,
        MrReport: allSubmenuItems.MrReport,
        customerHolding: allSubmenuItems.CustomerHolding,
        productionreport: allSubmenuItems.productionreport,
        Inventory: allSubmenuItems.Inventory,
        Distribution: allSubmenuItems.Distribution,

      };

    } else {
      return {}; // Default: no access
    }
  };

  // Helper function to determine if a menu section is active
  const isMenuActive = (menu) => {
    const allowedSubmenuItems = getAllowedSubmenuItems();
    const submenuItems = allowedSubmenuItems[menu] || [];
    return (
      submenuItems.includes(selected) ||
      (isDrawerOpen ? openMenu === menu : selectedMenu === menu)
    );
  };

  // Check if a menu section should be displayed based on role
  // const shouldDisplayMenu = (menu) => {
  //   const roleLower = role.toLowerCase();

  //   if (roleLower === "admin") {
  //     return !["Report", "MrReport", "customerHolding", "productionreport", "Inventory", "Distribution", "Utility", "Stores"].includes(menu);
  //   }

  //   if (roleLower === "management") {
  //     return ["Report", "logistics", "MrReport", "customerHolding", "productionreport", "Inventory", "Distribution"].includes(menu);
  //   }

  //   if (roleLower === "depot") {
  //     if (inside_plant === 1 || assigned_plant_id) {
  //       return ["Depot", "logistics", "Production", "Stores"].includes(menu);
  //     }
  //     return ["Depot", "logistics"].includes(menu);
  //   }

  //   if (roleLower === "plant") {
  //     if (inside_plant === 1 || assigned_depot_id) {
  //       return ["Production", "Stores", "Depot", "logistics"].includes(menu);
  //     }
  //     return ["Production", "Stores"].includes(menu);
  //   }

  //   const allowedSubmenuItems = getAllowedSubmenuItems();
  //   return !!allowedSubmenuItems[menu];
  // };

    const shouldDisplayMenu = (menu) => {
    const roleLower = role.toLowerCase();

  if (roleLower === "admin") {
  return !["Report", "MrReport", "customerHolding", "productionreport", "Inventory", "Distribution", "Utility", "Stores"].includes(menu);
}

    if (roleLower === "management") {
      return ["Report", "logistics", "MrReport", "customerHolding", "productionreport", "Inventory", "Distribution"].includes(menu);
    }

    if (roleLower === "depot") {
      return ["Depot", "logistics"].includes(menu);
    }

    if (roleLower === "plant") {
      return ["Production", "Stores"].includes(menu);
    }

    const allowedSubmenuItems = getAllowedSubmenuItems();
    return !!allowedSubmenuItems[menu];
  };


  // Define submenu content based on role
  const renderSubmenuItems = (menu) => {
    const allowedSubmenuItems = getAllowedSubmenuItems();
    const submenuItems = allowedSubmenuItems[menu] || [];
    const roleLower = role.toLowerCase();

    switch (menu) {
      case "sales":
        if (!submenuItems.length) return null;
        return (
          <>
            {submenuItems.includes("AddCustomer") && (
              <ListItemButton
                className={
                  selected === "AddCustomer"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("AddCustomer", "/masters/list-customer")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "AddCustomer"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Add Customer
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}
            {submenuItems.includes("CustomerPO") && (
              <ListItemButton
                className={
                  selected === "CustomerPO"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("CustomerPO", "/salesEntries/list-se")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "CustomerPO"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Customer PO
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}
            {submenuItems.includes("Sales_Order") && (
              <ListItemButton
                className={
                  selected === "Sales_Order"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("Sales_Order", "/salesEntries/list-so")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "Sales_Order"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Sales Order
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}
            {submenuItems.includes("SOSummary") && (
  <ListItemButton
    className={selected === "SOSummary" ? styles.selectedSubmenuItem : styles.submenuItem}
    onClick={() => handleSelect("SOSummary", "/salesEntries/so-summary")}
    sx={isDrawerOpen ? { pl: 4 } : {}}
  >
    <ListItemText className={selected === "SOSummary" ? styles.selectedText : styles.submenuText}>
      <Typography className={styles.ListItemText_all}>SO Summary</Typography>
    </ListItemText>
  </ListItemButton>
)}
            {submenuItems.includes("ViewCyl_Stock") && (
              <ListItemButton
                className={
                  selected === "ViewCyl_Stock"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("ViewCyl_Stock", "/salesEntries/ViewCyl_Stock")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "ViewCyl_Stock"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    View Cylinder Stock
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}
          </>
        );
      case "Stores":
        if (!submenuItems.length) return null;
        return (
          <>
            {/* {submenuItems.includes("cyl_collection_entry") && (
              <ListItemButton
                className={selected === "cyl_collection_entry" ? styles.selectedSubmenuItem : styles.submenuItem}
                onClick={() => handleSelect("cyl_collection_entry", "/storeEntries/List-pickup")}
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={selected === "cyl_collection_entry" ? styles.selectedText : styles.submenuText}
                >
                  <Typography className={styles.ListItemText_all}>Cylinder Collection Entry</Typography>
                </ListItemText>
              </ListItemButton>
            )} */}
            {/* {submenuItems.includes("Inward") && (
              <ListItemButton
                className={selected === "Inward" ? styles.selectedSubmenuItem : styles.submenuItem}
                onClick={() => handleSelect("Inward", "/storeEntries/list-ci")}
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={selected === "Inward" ? styles.selectedText : styles.submenuText}
                >
                  <Typography className={styles.ListItemText_all}>Inward Entry</Typography>
                </ListItemText>
              </ListItemButton>
            )} */}
            {submenuItems.includes("transfer_plant_entry") && (
              <ListItemButton
                className={
                  selected === "transfer_plant_entry"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "transfer_plant_entry",
                    "/LogisticDistribution/list-dc"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "transfer_plant_entry"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Transfer To Plant Entry
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

            {submenuItems.includes("AddSuppliers") && (
              <ListItemButton
                className={
                  selected === "AddSuppliers"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("AddSuppliers", "/masters/list-supplier")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "AddSuppliers"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Add Suppliers
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}
            {submenuItems.includes("GRNEntry") && (
              <ListItemButton
                className={
                  selected === "GRNEntry"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("GRNEntry", "/transactions/list-grn")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "GRNEntry"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    GRN / Material Receipts
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}
            {submenuItems.includes("RMStock") && (
              <ListItemButton
                className={
                  selected === "RMStock"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("RMStock", "/productionEntries/RMStock")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  classjourney
                  className={
                    selected === "RMStock"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    RM Stock Report
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}
            {/* {submenuItems.includes("GRNEntry") && (
              <ListItemButton
                className={selected === "GRNEntry" ? styles.selectedSubmenuItem : styles.submenuItem}
                onClick={() => handleSelect("GRNEntry", "/transactions/list-grn")}
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={selected === "GRNEntry" ? styles.selectedText : styles.submenuText}
                >
                  <Typography className={styles.ListItemText_all}>GRN</Typography>
                </ListItemText>
              </ListItemButton>
            )} */}

            {/* {submenuItems.includes("Stock") && (
              <ListItemButton
                className={selected === "Stock" ? styles.selectedSubmenuItem : styles.submenuItem}
                onClick={() => handleSelect("Stock", "/LogisticDistribution/list-dc")}
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  classjourney className={selected === "Stock" ? styles.selectedText : styles.submenuText}
                >
                  <Typography className={styles.ListItemText_all}>Stock</Typography>
                </ListItemText>
              </ListItemButton>
            )} */}


          </>
        );

      case "Depot":
        if (!submenuItems.length) return null;
        return (
          <>
            {submenuItems.includes("CylinderInwardList") && (
              <ListItemButton
                className={
                  selected === "CylinderInwardList"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("CylinderInwardList", "/storeEntries/list-ci")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "CylinderInwardList"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Inward Entry
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}
            {submenuItems.includes("ListEmptyDeliveryChallan") && (
              <ListItemButton
                className={
                  selected === "ListEmptyDeliveryChallan"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "ListEmptyDeliveryChallan",
                    "/transactions/List-edc"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "ListEmptyDeliveryChallan"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Empty Challan
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}


            {submenuItems.includes("DeliveryChallanList") && (
              <ListItemButton
                className={
                  selected === "DeliveryChallanList"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "DeliveryChallanList",
                    "/LogisticDistribution/list-dc"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "DeliveryChallanList"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Delivery Challan
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}



            {/* Add Transfer To Plant if inside_plant === 1 for depot, or always for admin */}
            {/* {((role.toLowerCase() === "depot" && inside_plant === 1) ||
              role.toLowerCase() === "admin") && ( */}
             {isInsidePlantDepot && (
<ListItemButton
  className={
    selected === "TransferToPlant"
      ? styles.selectedSubmenuItem
      : styles.submenuItem
  }
  onClick={() =>
    handleSelect(
      "TransferToPlant",
      "/storeEntries/Listtransertoplant"
    )
  }
  sx={isDrawerOpen ? { pl: 4 } : {}}
>
  <ListItemText
    className={
      selected === "TransferToPlant"
        ? styles.selectedText
        : styles.submenuText
    }
  >
    <Typography className={styles.ListItemText_all}>
      Transfer To Plant
    </Typography>
  </ListItemText>
</ListItemButton>
)}
              {/* )} */}

            {/* {submenuItems.includes("DriverActivityplanning") && (
              <ListItemButton
                className={
                  selected === "DriverActivityplanning"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "DriverActivityplanning",
                    "/storeEntries/list-dap"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "DriverActivityplanning"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Driver Activity Planning
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )} */}
            {submenuItems.includes("Cyl_Del_entry") && (
              <ListItemButton
                className={
                  selected === "Cyl_Del_entry"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "Cyl_Del_entry",
                    "/productionEntries/ListDeliveryEntry"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "Cyl_Del_entry"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Delivery Acknowledgement
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}
          </>
        );

      case "Production":
        if (!submenuItems.length) return null;
        // Remove Inward Entry and Delivery Challan from Plant section for all users
        let filteredSubmenuItems = submenuItems.filter(
          (item) =>
            item !== "CylinderInwardLists" && item !== "DeliveryChallans"
        );
        return (
          <>
            {/* {filteredSubmenuItems.includes("newreceipt") && (
              <ListItemButton
                className={selected === "newreceipt" ? styles.selectedSubmenuItem : styles.submenuItem}
                onClick={() => handleSelect("newreceipt", "/storeEntries/list-newrc")}
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={selected === "newreceipt" ? styles.selectedText : styles.submenuText}
                >
                  <Typography className={styles.ListItemText_all}>New Cylinder Receipts</Typography>
                </ListItemText>
              </ListItemButton>
              
            )} */}

            {filteredSubmenuItems.includes("CylinderInspectionEntry") && (
              <ListItemButton
                className={
                  selected === "CylinderInspectionEntry"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "CylinderInspectionEntry",
                    "/storeEntries/list-eci"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "CylinderInspectionEntry"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Inspection
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

            {filteredSubmenuItems.includes("ProductionEntry") && (
              <ListItemButton
                className={
                  selected === "ProductionEntry"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("ProductionEntry", "/productionEntries/list-pe")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "ProductionEntry"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Production / Filling
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}
            {filteredSubmenuItems.includes("QualityControlEntry") && (
              <ListItemButton
                className={
                  selected === "QualityControlEntry"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "QualityControlEntry",
                    "/productionEntries/list-qe"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "QualityControlEntry"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Quality Check / QC
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

 {/* Transfer to Depot — visible in Production/Plant section */}
            {/* <ListItemButton
              className={
                selected === "TransferToDepot"
                  ? styles.selectedSubmenuItem
                  : styles.submenuItem
              }
              onClick={() =>
                handleSelect(
                  "TransferToDepot",
                  "/storeEntries/list-transfer-to-depot"
                )
              }
              sx={isDrawerOpen ? { pl: 4 } : {}}
            >
              <ListItemText
                className={
                  selected === "TransferToDepot"
                    ? styles.selectedText
                    : styles.submenuText
                }
              >
                <Typography className={styles.ListItemText_all}>
                  Transfer To Depot
                </Typography>
              </ListItemText>
            </ListItemButton> */}


            {filteredSubmenuItems.includes("maintains") && (
              <ListItemButton
                className={
                  selected === "maintains"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("maintains", "/transactions/List-maintenance")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "maintains"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Maintenance
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

            {/* {submenuItems.includes("RMIssueEntry") && (
              <ListItemButton
                className={
                  selected === "RMIssueEntry"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("RMIssueEntry", "/productionEntries/ListRmissue")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "RMIssueEntry"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    RM Issue Entry
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )} */}

            {filteredSubmenuItems.includes("DeliveryChallans") && (
              <ListItemButton
                className={
                  selected === "DeliveryChallans"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "DeliveryChallans",
                    "/LogisticDistribution/list-dc"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "DeliveryChallans"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Delivery Challan
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}
          </>
        );

      case "logistics":
        if (!submenuItems.length) return null;
        return (
          <>
            {/* {submenuItems.includes("Internal_Transfer_Entry") && (
              <ListItemButton
                className={selected === "Internal_Transfer_Entry" ? styles.selectedSubmenuItem : styles.submenuItem}
                onClick={() => handleSelect("Internal_Transfer_Entry", "/storeEntries/list-ime")}
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={selected === "Internal_Transfer_Entry" ? styles.selectedText : styles.submenuText}
                >
                  <Typography className={styles.ListItemText_all}>Internal Transfer Entry</Typography>
                </ListItemText>
              </ListItemButton>
            )}
            {submenuItems.includes("DeliveryChallan") && (
              <ListItemButton
                className={selected === "DeliveryChallan" ? styles.selectedSubmenuItem : styles.submenuItem}
                onClick={() => handleSelect("DeliveryChallan", "/LogisticDistribution/list-dc")}
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={selected === "DeliveryChallan" ? styles.selectedText : styles.submenuText}
                >
                  <Typography className={styles.ListItemText_all}>Delivery Challan</Typography>
                </ListItemText>
              </ListItemButton>
            )} */}


            {submenuItems.includes("EmptyCollection") && (
              <ListItemButton
                className={
                  selected === "EmptyCollection"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("EmptyCollection", "/transactions/EmptyCollection")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "EmptyCollection"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Empty Collection
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

            {/* {submenuItems.includes("Tempo_Loading") && (
              <ListItemButton
                className={
                  selected === "Tempo_Loading"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "Tempo_Loading",
                    "/storeEntries/List-tempo-loading"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "Tempo_Loading"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Vehicle Loading
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )} */}


            {submenuItems.includes("Cyl_Del_entry") && (
              <ListItemButton
                className={
                  selected === "Cyl_Del_entry"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "Cyl_Del_entry",
                    "/productionEntries/ListDeliveryEntry"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "Cyl_Del_entry"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Delivery Acknowledgement
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

            {/* {submenuItems.includes("salesreturn") && (
              <ListItemButton
                className={
                  selected === "salesreturn"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("salesreturn", "/transactions/listsales")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "salesreturn"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Sales Return
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )} */}

            {/* {submenuItems.includes("DeliveryEntry") && (
              <ListItemButton
                className={selected === "DeliveryEntry" ? styles.selectedSubmenuItem : styles.submenuItem}
                onClick={() => handleSelect("DeliveryEntry", "/storeEntries/ListDeliveryEntry")}
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={selected === "DeliveryEntry" ? styles.selectedText : styles.submenuText}
                >
                  <Typography className={styles.ListItemText_all}>Cylinder Delivery Entry</Typography>
                </ListItemText>
              </ListItemButton>
            )} */}


          </>
        );

      case "Report":
        if (!submenuItems.length) return null;
        return (
          <>
            {submenuItems.includes("insepctionreport") && (
              <ListItemButton
                className={
                  selected === "insepctionreport"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "insepctionreport",
                    "/reportnew/InspectionReport"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "insepctionreport"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Insepection Summary
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

            {submenuItems.includes("productionentry") && (
              <ListItemButton
                className={
                  selected === "productionentry"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "productionentry",
                    "/reportnew/Prodductionreport"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "productionentry"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Production Entry Summary
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}



            {submenuItems.includes("qulityrport") && (
              <ListItemButton
                className={
                  selected === "qulityrport"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("qulityrport", "/reportnew/Qualitycontroreport")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "qulityrport"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Quality Control Summary
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}



            {submenuItems.includes("emptydeliverychllanreport") && (
              <ListItemButton
                className={
                  selected === "emptydeliverychllanreport"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("emptydeliverychllanreport", "/reportnew/emptychallan")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "emptydeliverychllanreport"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Empty Challan Summary
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}
            {submenuItems.includes("challanreport") && (
              <ListItemButton
                className={
                  selected === "challanreport"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("challanreport", "/reportnew/Challanreport")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "challanreport"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Delivery Challan Summary
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}
            {submenuItems.includes("maintenancereport") && (
              <ListItemButton
                className={
                  selected === "maintenancereport"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "maintenancereport",
                    "/reportnew/Maintenancereport"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "maintenancereport"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Maintenance Summary
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

            {submenuItems.includes("emptycolllection") && (
              <ListItemButton
                className={
                  selected === "emptycolllection"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "emptycolllection",
                    "/transactions/newcollection"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "emptycolllection"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Empty Collection Summary
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

            {/* {submenuItems.includes("CylinderUnderMaintenance") && (
              <ListItemButton
                className={selected === "CylinderUnderMaintenance" ? styles.selectedSubmenuItem : styles.submenuItem}
                onClick={() => handleSelect("CylinderUnderMaintenance", "/reportnew/CylinderUnderMaintenance")}
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={selected === "CylinderUnderMaintenance" ? styles.selectedText : styles.submenuText}
                >
                  <Typography className={styles.ListItemText_all}>Cylinder Under  Maintenance</Typography>
                </ListItemText>
              </ListItemButton>
            )} */}

            {submenuItems.includes("DailyDistributionReport") && (
              <ListItemButton
                className={
                  selected === "DailyDistributionReport"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "DailyDistributionReport",
                    "/reportnew/DailyDistributionReport"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "DailyDistributionReport"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Daily Distribution Summary
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

            {submenuItems.includes("EmptyCylinderInventory") && (
              <ListItemButton
                className={
                  selected === "EmptyCylinderInventory"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "EmptyCylinderInventory",
                    "/reportnew/CylinderInventory"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "EmptyCylinderInventory"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    {" "}
                    Cylinder Inventory Summary
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

            {submenuItems.includes("emptycylinderholding") && (
              <ListItemButton
                className={
                  selected === "emptycylinderholding"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "emptycylinderholding",
                    "/reportnew/EmptyCylinderHolding"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "emptycylinderholding"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    {" "}
                    Custmor Holding Report
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

            {/* {submenuItems.includes("FinishedGoodInventory") && (
              <ListItemButton
                className={
                  selected === "FinishedGoodInventory"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "FinishedGoodInventory",
                    "/reportnew/FinishedGoodInventory"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "FinishedGoodInventory"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Finished Good Inventory{" "}
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )} */}


            {submenuItems.includes("mrreport") && (
              <ListItemButton
                className={
                  selected === "mrreport"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() => handleSelect("mrreport", "/reportnew/mrreport")}
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "mrreport"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    MR Summary
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}


            {submenuItems.includes("productionquantityreport") && (
              <ListItemButton
                className={
                  selected === "productionquantityreport"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() => handleSelect("productionquantityreport", "/reportnew/productionquantityreport")}
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "productionquantityreport"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Production Quantity Report
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

           
            


            {submenuItems.includes("deliveryacknowledgment") && (
              <ListItemButton
                className={
                  selected === "deliveryacknowledgment"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() => handleSelect("deliveryacknowledgment", "/reportnew/deliveryacknowledgemet")}
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "deliveryacknowledgment"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Delivery Acknowledgment
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

            {submenuItems.includes("DepotWise") && (
              <ListItemButton
                className={
                  selected === "DepotWise"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() => handleSelect("DepotWise", "/reportnew/depotwise")}
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "DepotWise"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Depot Wise Summary
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

            {/* {submenuItems.includes("Plant_Wise_Cylinder_Stock") && (
              <ListItemButton
                className={
                  selected === "Plant_Wise_Cylinder_Stock"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "Plant_Wise_Cylinder_Stock",
                    "/reports/Plant_Wise_Cylinder_Stock"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "Plant_Wise_Cylinder_Stock"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Plant Wise Cylinder Stock
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )} */}
            {/* {submenuItems.includes("Cylinder_Wise_Cycle_Report") && (
              <ListItemButton
                className={
                  selected === "Cylinder_Wise_Cycle_Report"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "Cylinder_Wise_Cycle_Report",
                    "/reports/Cylinder_Wise_Cycle_Report"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "Cylinder_Wise_Cycle_Report"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Cylinder Wise Cycle Report
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )} */}
          </>
        );



      case "Utility":
        if (!submenuItems.length) return null;
        return (
          <>
            {submenuItems.includes("BOM") && (
              <ListItemButton
                className={
                  selected === "BOM"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() => handleSelect("BOM", "/utility/list-bom")}
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "BOM"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    BOM
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}
            {submenuItems.includes("Cylinder_NoTagno_Mapping") && (
              <ListItemButton
                className={
                  selected === "Cylinder_NoTagno_Mapping"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect(
                    "Cylinder_NoTagno_Mapping",
                    "/masters/ListCyltagmap"
                  )
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "Cylinder_NoTagno_Mapping"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Cylinder No-Tagno Mapping
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}
            {submenuItems.includes("UOM_Conversion") && (
              <ListItemButton
                className={
                  selected === "UOM_Conversion"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("UOM_Conversion", "/masters/list-uom-conversion")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "UOM_Conversion"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    UOM Conversion
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}
            {/* {submenuItems.includes("list-cpd") && (
              <ListItemButton
                className={
                  selected === "list-cpd"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() => handleSelect("list-cpd", "/masters/list-cpd")}
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "list-cpd"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Customer Product Details
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )} */}
          </>
        );

        

      case "MrReport":
        if (!submenuItems.length) return null;
        return (
          <>

            {submenuItems.includes("mrreport") && (
              <ListItemButton
                className={
                  selected === "mrreport"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("mrreport", "/reportnew/mrreport")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "mrreport"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    MR Report
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

          </>
        );



        
        //     case "customerHolding":
        // if (!submenuItems.length) return null;
        // return (
        //   <>

        //     {submenuItems.includes("emptycylinderholding") && (
        //       <ListItemButton
        //         className={
        //           selected === "emptycylinderholding"
        //             ? styles.selectedSubmenuItem
        //             : styles.submenuItem
        //         }
        //         onClick={() =>
        //           handleSelect("emptycylinderholding", "/reportnew/EmptyCylinderHolding")
        //         }
        //         sx={isDrawerOpen ? { pl: 4 } : {}}
        //       >
        //         <ListItemText
        //           className={
        //             selected === "emptycylinderholding"
        //               ? styles.selectedText
        //               : styles.submenuText
        //           }
        //         >
        //           <Typography className={styles.ListItemText_all}>
        //           Customer Ledger
        //           </Typography>
                   
        //         </ListItemText>
        //       </ListItemButton>
        //     )}

        //   </>
        // );


case "customerHolding":
    if (!submenuItems.length) return null;
    return (
      <>

        {submenuItems.includes("emptycylinderholding") && (
          <ListItemButton
            className={
              selected === "emptycylinderholding"
                ? styles.selectedSubmenuItem
                : styles.submenuItem
            }
            onClick={() =>
              handleSelect("emptycylinderholding", "/reportnew/EmptyCylinderHolding")
            }
            sx={isDrawerOpen ? { pl: 4 } : {}}
          >
            <ListItemText
              className={
                selected === "emptycylinderholding"
                  ? styles.selectedText
                  : styles.submenuText
              }
            >
              <Typography className={styles.ListItemText_all}>
              Customer Ledger
              </Typography>
            </ListItemText>
          </ListItemButton>
        )}

        {submenuItems.includes("customerholdingsummary") && (
          <ListItemButton
            className={
              selected === "customerholdingsummary"
                ? styles.selectedSubmenuItem
                : styles.submenuItem
            }
            onClick={() =>
              handleSelect("customerholdingsummary", "/reportnew/CustomerHoldingSummary")
            }
            sx={isDrawerOpen ? { pl: 4 } : {}}
          >
            <ListItemText
              className={
                selected === "customerholdingsummary"
                  ? styles.selectedText
                  : styles.submenuText
              }
            >
              <Typography className={styles.ListItemText_all}>
              Customer Holding Report
              </Typography>
            </ListItemText>
          </ListItemButton>
        )}

      </>
    );

       

      case "productionreport":
        if (!submenuItems.length) return null;
        return (
          <>

            {submenuItems.includes("productionentry") && (
              <ListItemButton
                className={
                  selected === "productionentry"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("productionentry", "/reportnew/Prodductionreport")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "productionentry"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Production Report
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

          </>
        );

      case "Distribution":
        if (!submenuItems.length) return null;
        return (
          <>

            {submenuItems.includes("DailyDistributionReport") && (
              <ListItemButton
                className={
                  selected === "DailyDistributionReport"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("DailyDistributionReport", "/reportnew/DailyDistributionReport")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "DailyDistributionReport"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Distribution Summary
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

          </>
        );

      case "Inventory":
        if (!submenuItems.length) return null;
        return (
          <>


            {submenuItems.includes("EmptyCylinderInventory") && (
              <ListItemButton
                className={
                  selected === "EmptyCylinderInventory"
                    ? styles.selectedSubmenuItem
                    : styles.submenuItem
                }
                onClick={() =>
                  handleSelect("EmptyCylinderInventory", "/reportnew/CylinderInventory")
                }
                sx={isDrawerOpen ? { pl: 4 } : {}}
              >
                <ListItemText
                  className={
                    selected === "EmptyCylinderInventory"
                      ? styles.selectedText
                      : styles.submenuText
                  }
                >
                  <Typography className={styles.ListItemText_all}>
                    Inventroy Report
                  </Typography>
                </ListItemText>
              </ListItemButton>
            )}

          </>
        );
      default:
        return null;
    }
  };

  const drawerContent = (
    <Box sx={{ padding: 0, margin: 0 }}>
      <Toolbar
        sx={{
          justifyContent: isDrawerOpen ? "flex-end" : "center",
          marginTop: "60px",
        }}
      >
       <IconButton
  onClick={handleDrawerWidthToggle}
  sx={{ 
    display: { xs: "none", sm: "none", md: "block" },
    color: "#fff"  // Add this
  }}
>
  {isDrawerOpen ? <MenuOpenIcon /> : <MenuIcon />}
</IconButton>
      </Toolbar>
      <List className={styles.sidebarContainer}>
        {/* Dashboard (visible to all roles) */}
        <ListItemButton
          className={
            selected === "/dashboard" ? styles.expandedSection : styles.menuItem
          }
          onClick={() => handleSelect("/dashboard", "/dashboard")}
        >
          <ListItemIcon className={styles.iconContainer}>
            {selected === "/dashboard" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9.72719 3H4.27268C3.57089 3 3 3.58873 3 4.31244V7.68742C3 8.41127 3.57089 9 4.27268 9H9.72719C10.4291 9 11 8.41127 11 7.68742V4.31244C11 3.58873 10.4291 3 9.72719 3Z"
                  fill="#ffffff"
                />
                <path
                  d="M9.72719 10H4.27268C3.57089 10 3 10.6168 3 11.3751V19.6251C3 20.3832 3.57089 21 4.27268 21H9.72719C10.4291 21 11 20.3832 11 19.6251V11.3751C11 10.6168 10.4291 10 9.72719 10Z"
                  fill="#ffffff"
                />
                <path
                  d="M19.7273 15H14.2728C13.5709 15 13 15.5887 13 16.3126V19.6876C13 20.4113 13.5709 21 14.2728 21H19.7273C20.4291 21 21 20.4113 21 19.6876V16.3126C21 15.5887 20.4291 15 19.7273 15Z"
                  fill="#ffffff"
                />
                <path
                  d="M19.7273 3H14.2728C13.5709 3 13 3.61676 13 4.37495V12.6249C13 13.3832 13.5709 14 14.2728 14H19.7273C20.4291 14 21 13.3832 21 12.6249V4.37495C21 3.61676 20.4291 3 19.7273 3Z"
                  fill="#ffffff"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9.72719 3H4.27268C3.57089 3 3 3.58873 3 4.31244V7.68742C3 8.41127 3.57089 9 4.27268 9H9.72719C10.4291 9 11 8.41127 11 7.68742V4.31244C11 3.58873 10.4291 3 9.72719 3Z"
                  fill="#ffffff"
                  fill-opacity="0.69"
                />
                <path
                  d="M9.72719 10H4.27268C3.57089 10 3 10.6168 3 11.3751V19.6251C3 20.3832 3.57089 21 4.27268 21H9.72719C10.4291 21 11 20.3832 11 19.6251V11.3751C11 10.6168 10.4291 10 9.72719 10Z"
                  fill="#ffffff"
                  fill-opacity="0.69"
                />
                <path
                  d="M19.7273 15H14.2728C13.5709 15 13 15.5887 13 16.3126V19.6876C13 20.4113 13.5709 21 14.2728 21H19.7273C20.4291 21 21 20.4113 21 19.6876V16.3126C21 15.5887 20.4291 15 19.7273 15Z"
                  fill="#ffffff"
                  fill-opacity="0.69"
                />
                <path
                  d="M19.7273 3H14.2728C13.5709 3 13 3.61676 13 4.37495V12.6249C13 13.3832 13.5709 14 14.2728 14H19.7273C20.4291 14 21 13.3832 21 12.6249V4.37495C21 3.61676 20.4291 3 19.7273 3Z"
                  fill="#ffffff"
                  fill-opacity="0.69"
                />
              </svg>
            )}
          </ListItemIcon>
          <ListItemText
            className={
              selected === "/dashboard" ? styles.selectedText : styles.menuText
            }
            sx={{
              display: { xs: "block", md: isDrawerOpen ? "block" : "none" },
            }}
          >
            <Typography className={styles.ListItemText_all}>
              Dashboard
            </Typography>
          </ListItemText>
        </ListItemButton>

        {/* Sales Section */}
        {shouldDisplayMenu("sales") && (
          <>
            <ListItemButton
              className={
                isMenuActive("sales") ? styles.expandedSection : styles.menuItem
              }
              onClick={(event) => {
                if (isDrawerOpen) {
                  handleMenuToggle("sales");
                } else {
                  handleMenuPopoverToggle(event, "sales");
                }
              }}
            >
              <ListItemIcon className={styles.iconContainer}>
                {isMenuActive("sales") ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M6.6 4H17.4C19.38 4 21 5.59986 21 7.55525C21 9.06623 20.1 10.3106 18.75 10.8438V7.55525C18.75 7.19972 18.57 6.8442 18.39 6.57755C18.21 6.31091 17.76 6.22203 17.4 6.22203H6.6C6.24 6.22203 5.88 6.39979 5.61 6.57755C5.34 6.75532 5.25 7.19972 5.25 7.55525V10.8438C3.9 10.3106 3 9.06623 3 7.55525C3 5.59986 4.62 4 6.6 4Z"
                      fill="#ffffff"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M17.4002 7.55664V18.2224C17.4002 19.2001 16.5902 20 15.6002 20H8.40022C7.41022 20 6.60022 19.2001 6.60022 18.2224V7.55664H17.4002ZM10.6502 14.2227L11.2802 14.8449V11.1119C11.2802 10.7564 11.5502 10.4008 12.0002 10.4008C12.4502 10.4008 12.7202 10.6675 12.7202 11.1119V14.8449L13.3502 14.2227C13.6202 13.9561 14.0702 13.9561 14.3402 14.2227C14.6102 14.4894 14.6102 14.9338 14.3402 15.2004L13.1702 16.3559C12.5402 16.978 11.5502 16.978 10.9202 16.3559L9.75022 15.2004C9.48022 14.9338 9.48022 14.4894 9.75022 14.2227C10.0202 13.9561 10.3802 13.9561 10.6502 14.2227Z"
                      fill="#ffffff"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M6.6 4H17.4C19.38 4 21 5.59986 21 7.55525C21 9.06623 20.1 10.3106 18.75 10.8438V7.55525C18.75 7.19972 18.57 6.8442 18.39 6.57755C18.21 6.31091 17.76 6.22203 17.4 6.22203H6.6C6.24 6.22203 5.88 6.39979 5.61 6.57755C5.34 6.75532 5.25 7.19972 5.25 7.55525V10.8438C3.9 10.3106 3 9.06623 3 7.55525C3 5.59986 4.62 4 6.6 4Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M17.4002 7.55664V18.2224C17.4002 19.2001 16.5902 20 15.6002 20H8.40022C7.41022 20 6.60022 19.2001 6.60022 18.2224V7.55664H17.4002ZM10.6502 14.2227L11.2802 14.8449V11.1119C11.2802 10.7564 11.5502 10.4008 12.0002 10.4008C12.4502 10.4008 12.7202 10.6675 12.7202 11.1119V14.8449L13.3502 14.2227C13.6202 13.9561 14.0702 13.9561 14.3402 14.2227C14.6102 14.4894 14.6102 14.9338 14.3402 15.2004L13.1702 16.3559C12.5402 16.978 11.5502 16.978 10.9202 16.3559L9.75022 15.2004C9.48022 14.9338 9.48022 14.4894 9.75022 14.2227C10.0202 13.9561 10.3802 13.9561 10.6502 14.2227Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                  </svg>
                )}
              </ListItemIcon>
              <ListItemText
                className={
                  isMenuActive("sales") ? styles.selectedText : styles.menuText
                }
                sx={{
                  display: { xs: "block", md: isDrawerOpen ? "block" : "none" },
                }}
              >
                <Typography className={styles.ListItemText_all}>
                  Sales
                </Typography>
              </ListItemText>
              {isDrawerOpen &&
                (openMenu === "sales" ? (
                  <ExpandLess className={styles.expandIcon} />
                ) : (
                  <ExpandMore className={styles.expandIcon} />
                ))}
            </ListItemButton>
            {isDrawerOpen ? (
              <Collapse in={openMenu === "sales"} timeout="auto" unmountOnExit>
                <List
                  component="div"
                  disablePadding
                  className={styles.submenuList}
                >
                  {renderSubmenuItems("sales")}
                </List>
              </Collapse>
            ) : (
              <Popover
                open={selectedMenu === "sales"}
                anchorEl={anchorEl}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
                sx={{
                  "& .MuiPopover-paper": {
                    boxShadow: 1,
                    padding: "10px",
                    backgroundColor: "#fff",
                    marginLeft: "12px",
                  },
                }}
              >
                <List
                  component="div"
                  className={`${styles.submenuList} popoverSubmenuList`}
                >
                  {renderSubmenuItems("sales")}
                </List>
              </Popover>
            )}
          </>
        )}

        {/* Stores Section */}
        {shouldDisplayMenu("Stores") && (
          <>
            <ListItemButton
              className={
                isMenuActive("Stores")
                  ? styles.expandedSection
                  : styles.menuItem
              }
              onClick={(event) => {
                if (isDrawerOpen) {
                  handleMenuToggle("Stores");
                } else {
                  handleMenuPopoverToggle(event, "Stores");
                }
              }}
            >
              <ListItemIcon className={styles.iconContainer}>
                {isMenuActive("Stores") ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M6.6 20H17.4C19.38 20 21 18.4001 21 16.4448C21 14.9338 20.1 13.6894 18.75 13.1562V16.4448C18.75 16.8003 18.57 17.1558 18.39 17.4224C18.21 17.6891 17.76 17.778 17.4 17.778H6.6C6.24 17.778 5.88 17.6002 5.61 17.4224C5.34 17.2447 5.25 16.8003 5.25 16.4448V13.1562C3.9 13.6894 3 14.9338 3 16.4448C3 18.4001 4.62 20 6.6 20Z"
                      fill="#ffffff"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M17.4002 16.4434V5.77762C17.4002 4.79993 16.5902 4 15.6002 4H8.40022C7.41022 4 6.60022 4.79993 6.60022 5.77762V16.4434H17.4002ZM10.6502 9.77728L11.2802 9.15511V12.8881C11.2802 13.2436 11.5502 13.5992 12.0002 13.5992C12.4502 13.5992 12.7202 13.3325 12.7202 12.8881V9.15511L13.3502 9.77728C13.6202 10.0439 14.0702 10.0439 14.3402 9.77728C14.6102 9.51063 14.6102 9.06623 14.3402 8.79958L13.1702 7.64413C12.5402 7.02196 11.5502 7.02196 10.9202 7.64413L9.75022 8.79958C9.48022 9.06623 9.48022 9.51063 9.75022 9.77728C10.0202 10.0439 10.3802 10.0439 10.6502 9.77728Z"
                      fill="#ffffff"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M6.6 20H17.4C19.38 20 21 18.4001 21 16.4448C21 14.9338 20.1 13.6894 18.75 13.1562V16.4448C18.75 16.8003 18.57 17.1558 18.39 17.4224C18.21 17.6891 17.76 17.778 17.4 17.778H6.6C6.24 17.778 5.88 17.6002 5.61 17.4224C5.34 17.2447 5.25 16.8003 5.25 16.4448V13.1562C3.9 13.6894 3 14.9338 3 16.4448C3 18.4001 4.62 20 6.6 20Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M17.4002 16.4434V5.77762C17.4002 4.79993 16.5902 4 15.6002 4H8.40022C7.41022 4 6.60022 4.79993 6.60022 5.77762V16.4434H17.4002ZM10.6502 9.77728L11.2802 9.15511V12.8881C11.2802 13.2436 11.5502 13.5992 12.0002 13.5992C12.4502 13.5992 12.7202 13.3325 12.7202 12.8881V9.15511L13.3502 9.77728C13.6202 10.0439 14.0702 10.0439 14.3402 9.77728C14.6102 9.51063 14.6102 9.06623 14.3402 8.79958L13.1702 7.64413C12.5402 7.02196 11.5502 7.02196 10.9202 7.64413L9.75022 8.79958C9.48022 9.06623 9.48022 9.51063 9.75022 9.77728C10.0202 10.0439 10.3802 10.0439 10.6502 9.77728Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                  </svg>
                )}
              </ListItemIcon>
              <ListItemText
                className={
                  isMenuActive("Stores") ? styles.selectedText : styles.menuText
                }
                sx={{
                  display: { xs: "block", md: isDrawerOpen ? "block" : "none" },
                }}
              >
                <Typography className={styles.ListItemText_all}>
                  RM Stores
                </Typography>
              </ListItemText>
              {isDrawerOpen &&
                (openMenu === "Stores" ? (
                  <ExpandLess className={styles.expandIcon} />
                ) : (
                  <ExpandMore className={styles.expandIcon} />
                ))}
            </ListItemButton>
            {isDrawerOpen ? (
              <Collapse in={openMenu === "Stores"} timeout="auto" unmountOnExit>
                <List
                  component="div"
                  disablePadding
                  className={styles.submenuList}
                >
                  {renderSubmenuItems("Stores")}
                </List>
              </Collapse>
            ) : (
              <Popover
                open={selectedMenu === "Stores"}
                anchorEl={anchorEl}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
                sx={{
                  "& .MuiPopover-paper": {
                    boxShadow: 1,
                    padding: "10px",
                    backgroundColor: "#fff",
                    marginLeft: "12px",
                  },
                }}
              >
                <List
                  component="div"
                  className={`${styles.submenuList} popoverSubmenuList`}
                >
                  {renderSubmenuItems("Stores")}
                </List>
              </Popover>
            )}
          </>
        )}


        {/* Cylinder Location Entry - standalone item, only for admin / plant / depot */}
{/* {["admin"].includes(role.toLowerCase()) && (
  <ListItemButton
    className={
      selected === "CylinderLocationEntry" ? styles.expandedSection : styles.menuItem
    }
    onClick={() =>
      handleSelect("CylinderLocationEntry", "/masters/cylinder-location-entry")
    }
  >
    <ListItemIcon className={styles.iconContainer}>
      <LocationOnIcon sx={{ color: "#ffffff", fontSize: 20 }} />
    </ListItemIcon>
    <ListItemText
      className={
        selected === "CylinderLocationEntry" ? styles.selectedText : styles.menuText
      }
    >
      <Typography className={styles.ListItemText_all}>
        Cylinder Location Entry
      </Typography>
    </ListItemText>
  </ListItemButton>
)} */}

        {/* Production Section */}
        {shouldDisplayMenu("Depot") && (
          <>
            <ListItemButton
              className={
                isMenuActive("Depot") ? styles.expandedSection : styles.menuItem
              }
              onClick={(event) => {
                if (isDrawerOpen) {
                  handleMenuToggle("Depot");
                } else {
                  handleMenuPopoverToggle(event, "Depot");
                }
              }}
            >
              <ListItemIcon className={styles.iconContainer}>
                {isMenuActive("Depot") ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M18.4016 12.5583H17.0096C17.1515 12.9145 17.229 13.2989 17.229 13.6996V18.5234C17.229 18.6905 17.1973 18.8508 17.1396 18.9999H19.441C20.3006 18.9999 21 18.3587 21 17.5705V14.9407C21 13.6271 19.8344 12.5583 18.4016 12.5583Z"
                      fill="#ffffff"
                    />
                    <path
                      d="M6.77104 13.6996C6.77104 13.2989 6.84856 12.9146 6.99045 12.5584H5.5984C4.16564 12.5584 3 13.6271 3 14.9408V17.5705C3 18.3587 3.69936 19 4.55904 19H6.86044C6.80275 18.8508 6.77104 18.6905 6.77104 18.5235V13.6996Z"
                      fill="#ffffff"
                    />
                    <path
                      d="M13.5912 11.3171H10.4088C8.97605 11.3171 7.8104 12.3859 7.8104 13.6996V18.5235C7.8104 18.7866 8.04307 19 8.33008 19H15.67C15.957 19 16.1896 18.7866 16.1896 18.5235V13.6996C16.1896 12.3859 15.024 11.3171 13.5912 11.3171Z"
                      fill="#ffffff"
                    />
                    <path
                      d="M12 5C10.2769 5 8.87511 6.28532 8.87511 7.86522C8.87511 8.93686 9.5202 9.87278 10.4729 10.3642C10.9247 10.5972 11.4457 10.7304 12 10.7304C12.5544 10.7304 13.0753 10.5972 13.5272 10.3642C14.4799 9.87278 15.1249 8.93682 15.1249 7.86522C15.1249 6.28535 13.7231 5 12 5Z"
                      fill="#ffffff"
                    />
                    <path
                      d="M6.51275 7.67059C5.22409 7.67059 4.17573 8.63182 4.17573 9.81338C4.17573 10.9949 5.22409 11.9562 6.51275 11.9562C6.83963 11.9562 7.15091 11.8941 7.43367 11.7825C7.92255 11.5895 8.32566 11.2479 8.57509 10.82C8.75017 10.5196 8.84977 10.177 8.84977 9.81338C8.84977 8.63186 7.8014 7.67059 6.51275 7.67059Z"
                      fill="#ffffff"
                    />
                    <path
                      d="M17.4873 7.67059C16.1986 7.67059 15.1503 8.63182 15.1503 9.81338C15.1503 10.177 15.2499 10.5197 15.4249 10.82C15.6744 11.2479 16.0775 11.5895 16.5664 11.7825C16.8491 11.8941 17.1604 11.9562 17.4873 11.9562C18.7759 11.9562 19.8243 10.9949 19.8243 9.81338C19.8243 8.63182 18.7759 7.67059 17.4873 7.67059Z"
                      fill="#ffffff"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M18.4016 12.5583H17.0096C17.1515 12.9145 17.229 13.2989 17.229 13.6996V18.5234C17.229 18.6905 17.1973 18.8508 17.1396 18.9999H19.441C20.3006 18.9999 21 18.3587 21 17.5705V14.9407C21 13.6271 19.8344 12.5583 18.4016 12.5583Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      d="M6.77104 13.6996C6.77104 13.2989 6.84856 12.9146 6.99045 12.5584H5.5984C4.16564 12.5584 3 13.6271 3 14.9408V17.5705C3 18.3587 3.69936 19 4.55904 19H6.86044C6.80275 18.8508 6.77104 18.6905 6.77104 18.5235V13.6996Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      d="M13.5912 11.3171H10.4088C8.97605 11.3171 7.8104 12.3859 7.8104 13.6996V18.5235C7.8104 18.7866 8.04307 19 8.33008 19H15.67C15.957 19 16.1896 18.7866 16.1896 18.5235V13.6996C16.1896 12.3859 15.024 11.3171 13.5912 11.3171Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      d="M12 5C10.2769 5 8.87511 6.28532 8.87511 7.86522C8.87511 8.93686 9.5202 9.87278 10.4729 10.3642C10.9247 10.5972 11.4457 10.7304 12 10.7304C12.5544 10.7304 13.0753 10.5972 13.5272 10.3642C14.4799 9.87278 15.1249 8.93682 15.1249 7.86522C15.1249 6.28535 13.7231 5 12 5Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      d="M6.51275 7.67059C5.22409 7.67059 4.17573 8.63182 4.17573 9.81338C4.17573 10.9949 5.22409 11.9562 6.51275 11.9562C6.83963 11.9562 7.15091 11.8941 7.43367 11.7825C7.92255 11.5895 8.32566 11.2479 8.57509 10.82C8.75017 10.5196 8.84977 10.177 8.84977 9.81338C8.84977 8.63186 7.8014 7.67059 6.51275 7.67059Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      d="M17.4873 7.67059C16.1986 7.67059 15.1503 8.63182 15.1503 9.81338C15.1503 10.177 15.2499 10.5197 15.4249 10.82C15.6744 11.2479 16.0775 11.5895 16.5664 11.7825C16.8491 11.8941 17.1604 11.9562 17.4873 11.9562C18.7759 11.9562 19.8243 10.9949 19.8243 9.81338C19.8243 8.63182 18.7759 7.67059 17.4873 7.67059Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                  </svg>
                )}
              </ListItemIcon>
              <ListItemText
                className={
                  isMenuActive("Depot") ? styles.selectedText : styles.menuText
                }
                sx={{
                  display: { xs: "block", md: isDrawerOpen ? "block" : "none" },
                }}
              >
                <Typography className={styles.ListItemText_all}>
                  Depot
                </Typography>
              </ListItemText>
              {isDrawerOpen &&
                (openMenu === "Depot" ? (
                  <ExpandLess className={styles.expandIcon} />
                ) : (
                  <ExpandMore className={styles.expandIcon} />
                ))}
            </ListItemButton>
            {isDrawerOpen ? (
              <Collapse in={openMenu === "Depot"} timeout="auto" unmountOnExit>
                <List
                  component="div"
                  disablePadding
                  className={styles.submenuList}
                >
                  {renderSubmenuItems("Depot")}
                </List>
              </Collapse>
            ) : (
              <Popover
                open={selectedMenu === "Depot"}
                anchorEl={anchorEl}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
                sx={{
                  "& .MuiPopover-paper": {
                    boxShadow: 1,
                    padding: "10px",
                    backgroundColor: "#fff",
                    marginLeft: "12px",
                  },
                }}
              >
                <List
                  component="div"
                  className={`${styles.submenuList} popoverSubmenuList`}
                >
                  {renderSubmenuItems("Depot")}
                </List>
              </Popover>
            )}
          </>
        )}

        {/* Production Section */}
        {shouldDisplayMenu("Production") && (
          <>
            <ListItemButton
              className={
                isMenuActive("Production")
                  ? styles.expandedSection
                  : styles.menuItem
              }
              onClick={(event) => {
                if (isDrawerOpen) {
                  handleMenuToggle("Production");
                } else {
                  handleMenuPopoverToggle(event, "Production");
                }
              }}
            >
              <ListItemIcon className={styles.iconContainer}>
                {isMenuActive("Production") ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M18.4016 12.5583H17.0096C17.1515 12.9145 17.229 13.2989 17.229 13.6996V18.5234C17.229 18.6905 17.1973 18.8508 17.1396 18.9999H19.441C20.3006 18.9999 21 18.3587 21 17.5705V14.9407C21 13.6271 19.8344 12.5583 18.4016 12.5583Z"
                      fill="#ffffff"
                    />
                    <path
                      d="M6.77104 13.6996C6.77104 13.2989 6.84856 12.9146 6.99045 12.5584H5.5984C4.16564 12.5584 3 13.6271 3 14.9408V17.5705C3 18.3587 3.69936 19 4.55904 19H6.86044C6.80275 18.8508 6.77104 18.6905 6.77104 18.5235V13.6996Z"
                      fill="#ffffff"
                    />
                    <path
                      d="M13.5912 11.3171H10.4088C8.97605 11.3171 7.8104 12.3859 7.8104 13.6996V18.5235C7.8104 18.7866 8.04307 19 8.33008 19H15.67C15.957 19 16.1896 18.7866 16.1896 18.5235V13.6996C16.1896 12.3859 15.024 11.3171 13.5912 11.3171Z"
                      fill="#ffffff"
                    />
                    <path
                      d="M12 5C10.2769 5 8.87511 6.28532 8.87511 7.86522C8.87511 8.93686 9.5202 9.87278 10.4729 10.3642C10.9247 10.5972 11.4457 10.7304 12 10.7304C12.5544 10.7304 13.0753 10.5972 13.5272 10.3642C14.4799 9.87278 15.1249 8.93682 15.1249 7.86522C15.1249 6.28535 13.7231 5 12 5Z"
                      fill="#ffffff"
                    />
                    <path
                      d="M6.51275 7.67059C5.22409 7.67059 4.17573 8.63182 4.17573 9.81338C4.17573 10.9949 5.22409 11.9562 6.51275 11.9562C6.83963 11.9562 7.15091 11.8941 7.43367 11.7825C7.92255 11.5895 8.32566 11.2479 8.57509 10.82C8.75017 10.5196 8.84977 10.177 8.84977 9.81338C8.84977 8.63186 7.8014 7.67059 6.51275 7.67059Z"
                      fill="#ffffff"
                    />
                    <path
                      d="M17.4873 7.67059C16.1986 7.67059 15.1503 8.63182 15.1503 9.81338C15.1503 10.177 15.2499 10.5197 15.4249 10.82C15.6744 11.2479 16.0775 11.5895 16.5664 11.7825C16.8491 11.8941 17.1604 11.9562 17.4873 11.9562C18.7759 11.9562 19.8243 10.9949 19.8243 9.81338C19.8243 8.63182 18.7759 7.67059 17.4873 7.67059Z"
                      fill="#ffffff"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M18.4016 12.5583H17.0096C17.1515 12.9145 17.229 13.2989 17.229 13.6996V18.5234C17.229 18.6905 17.1973 18.8508 17.1396 18.9999H19.441C20.3006 18.9999 21 18.3587 21 17.5705V14.9407C21 13.6271 19.8344 12.5583 18.4016 12.5583Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      d="M6.77104 13.6996C6.77104 13.2989 6.84856 12.9146 6.99045 12.5584H5.5984C4.16564 12.5584 3 13.6271 3 14.9408V17.5705C3 18.3587 3.69936 19 4.55904 19H6.86044C6.80275 18.8508 6.77104 18.6905 6.77104 18.5235V13.6996Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      d="M13.5912 11.3171H10.4088C8.97605 11.3171 7.8104 12.3859 7.8104 13.6996V18.5235C7.8104 18.7866 8.04307 19 8.33008 19H15.67C15.957 19 16.1896 18.7866 16.1896 18.5235V13.6996C16.1896 12.3859 15.024 11.3171 13.5912 11.3171Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      d="M12 5C10.2769 5 8.87511 6.28532 8.87511 7.86522C8.87511 8.93686 9.5202 9.87278 10.4729 10.3642C10.9247 10.5972 11.4457 10.7304 12 10.7304C12.5544 10.7304 13.0753 10.5972 13.5272 10.3642C14.4799 9.87278 15.1249 8.93682 15.1249 7.86522C15.1249 6.28535 13.7231 5 12 5Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      d="M6.51275 7.67059C5.22409 7.67059 4.17573 8.63182 4.17573 9.81338C4.17573 10.9949 5.22409 11.9562 6.51275 11.9562C6.83963 11.9562 7.15091 11.8941 7.43367 11.7825C7.92255 11.5895 8.32566 11.2479 8.57509 10.82C8.75017 10.5196 8.84977 10.177 8.84977 9.81338C8.84977 8.63186 7.8014 7.67059 6.51275 7.67059Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      d="M17.4873 7.67059C16.1986 7.67059 15.1503 8.63182 15.1503 9.81338C15.1503 10.177 15.2499 10.5197 15.4249 10.82C15.6744 11.2479 16.0775 11.5895 16.5664 11.7825C16.8491 11.8941 17.1604 11.9562 17.4873 11.9562C18.7759 11.9562 19.8243 10.9949 19.8243 9.81338C19.8243 8.63182 18.7759 7.67059 17.4873 7.67059Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                  </svg>
                )}
              </ListItemIcon>
              <ListItemText
                className={
                  isMenuActive("Production")
                    ? styles.selectedText
                    : styles.menuText
                }
                sx={{
                  display: { xs: "block", md: isDrawerOpen ? "block" : "none" },
                }}
              >
                <Typography className={styles.ListItemText_all}>
                  Plant
                </Typography>
              </ListItemText>
              {isDrawerOpen &&
                (openMenu === "Production" ? (
                  <ExpandLess className={styles.expandIcon} />
                ) : (
                  <ExpandMore className={styles.expandIcon} />
                ))}
            </ListItemButton>
            {isDrawerOpen ? (
              <Collapse
                in={openMenu === "Production"}
                timeout="auto"
                unmountOnExit
              >
                <List
                  component="div"
                  disablePadding
                  className={styles.submenuList}
                >
                  {renderSubmenuItems("Production")}
                </List>
              </Collapse>
            ) : (
              <Popover
                open={selectedMenu === "Production"}
                anchorEl={anchorEl}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
                sx={{
                  "& .MuiPopover-paper": {
                    boxShadow: 1,
                    padding: "10px",
                    backgroundColor: "#fff",
                    marginLeft: "12px",
                  },
                }}
              >
                <List
                  component="div"
                  className={`${styles.submenuList} popoverSubmenuList`}
                >
                  {renderSubmenuItems("Production")}
                </List>
              </Popover>
            )}
          </>
        )}

        {/* Distribution Section */}
        {shouldDisplayMenu("logistics") && (
          <>
            <ListItemButton
              className={
                isMenuActive("logistics")
                  ? styles.expandedSection
                  : styles.menuItem
              }
              onClick={(event) => {
                if (isDrawerOpen) {
                  handleMenuToggle("logistics");
                } else {
                  handleMenuPopoverToggle(event, "logistics");
                }
              }}
            >
              <ListItemIcon className={styles.iconContainer}>
                {isMenuActive("logistics") ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M18.4016 12.5583H17.0096C17.1515 12.9145 17.229 13.2989 17.229 13.6996V18.5234C17.229 18.6905 17.1973 18.8508 17.1396 18.9999H19.441C20.3006 18.9999 21 18.3587 21 17.5705V14.9407C21 13.6271 19.8344 12.5583 18.4016 12.5583Z"
                      fill="#ffffff"
                    />
                    <path
                      d="M6.77104 13.6996C6.77104 13.2989 6.84856 12.9146 6.99045 12.5584H5.5984C4.16564 12.5584 3 13.6271 3 14.9408V17.5705C3 18.3587 3.69936 19 4.55904 19H6.86044C6.80275 18.8508 6.77104 18.6905 6.77104 18.5235V13.6996Z"
                      fill="#ffffff"
                    />
                    <path
                      d="M13.5912 11.3171H10.4088C8.97605 11.3171 7.8104 12.3859 7.8104 13.6996V18.5235C7.8104 18.7866 8.04307 19 8.33008 19H15.67C15.957 19 16.1896 18.7866 16.1896 18.5235V13.6996C16.1896 12.3859 15.024 11.3171 13.5912 11.3171Z"
                      fill="#ffffff"
                    />
                    <path
                      d="M12 5C10.2769 5 8.87511 6.28532 8.87511 7.86522C8.87511 8.93686 9.5202 9.87278 10.4729 10.3642C10.9247 10.5972 11.4457 10.7304 12 10.7304C12.5544 10.7304 13.0753 10.5972 13.5272 10.3642C14.4799 9.87278 15.1249 8.93682 15.1249 7.86522C15.1249 6.28535 13.7231 5 12 5Z"
                      fill="#ffffff"
                    />
                    <path
                      d="M6.51275 7.67059C5.22409 7.67059 4.17573 8.63182 4.17573 9.81338C4.17573 10.9949 5.22409 11.9562 6.51275 11.9562C6.83963 11.9562 7.15091 11.8941 7.43367 11.7825C7.92255 11.5895 8.32566 11.2479 8.57509 10.82C8.75017 10.5196 8.84977 10.177 8.84977 9.81338C8.84977 8.63186 7.8014 7.67059 6.51275 7.67059Z"
                      fill="#ffffff"
                    />
                    <path
                      d="M17.4873 7.67059C16.1986 7.67059 15.1503 8.63182 15.1503 9.81338C15.1503 10.177 15.2499 10.5197 15.4249 10.82C15.6744 11.2479 16.0775 11.5895 16.5664 11.7825C16.8491 11.8941 17.1604 11.9562 17.4873 11.9562C18.7759 11.9562 19.8243 10.9949 19.8243 9.81338C19.8243 8.63182 18.7759 7.67059 17.4873 7.67059Z"
                      fill="#ffffff"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M18.4016 12.5583H17.0096C17.1515 12.9145 17.229 13.2989 17.229 13.6996V18.5234C17.229 18.6905 17.1973 18.8508 17.1396 18.9999H19.441C20.3006 18.9999 21 18.3587 21 17.5705V14.9407C21 13.6271 19.8344 12.5583 18.4016 12.5583Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      d="M6.77104 13.6996C6.77104 13.2989 6.84856 12.9146 6.99045 12.5584H5.5984C4.16564 12.5584 3 13.6271 3 14.9408V17.5705C3 18.3587 3.69936 19 4.55904 19H6.86044C6.80275 18.8508 6.77104 18.6905 6.77104 18.5235V13.6996Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      d="M13.5912 11.3171H10.4088C8.97605 11.3171 7.8104 12.3859 7.8104 13.6996V18.5235C7.8104 18.7866 8.04307 19 8.33008 19H15.67C15.957 19 16.1896 18.7866 16.1896 18.5235V13.6996C16.1896 12.3859 15.024 11.3171 13.5912 11.3171Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      d="M12 5C10.2769 5 8.87511 6.28532 8.87511 7.86522C8.87511 8.93686 9.5202 9.87278 10.4729 10.3642C10.9247 10.5972 11.4457 10.7304 12 10.7304C12.5544 10.7304 13.0753 10.5972 13.5272 10.3642C14.4799 9.87278 15.1249 8.93682 15.1249 7.86522C15.1249 6.28535 13.7231 5 12 5Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      d="M6.51275 7.67059C5.22409 7.67059 4.17573 8.63182 4.17573 9.81338C4.17573 10.9949 5.22409 11.9562 6.51275 11.9562C6.83963 11.9562 7.15091 11.8941 7.43367 11.7825C7.92255 11.5895 8.32566 11.2479 8.57509 10.82C8.75017 10.5196 8.84977 10.177 8.84977 9.81338C8.84977 8.63186 7.8014 7.67059 6.51275 7.67059Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      d="M17.4873 7.67059C16.1986 7.67059 15.1503 8.63182 15.1503 9.81338C15.1503 10.177 15.2499 10.5197 15.4249 10.82C15.6744 11.2479 16.0775 11.5895 16.5664 11.7825C16.8491 11.8941 17.1604 11.9562 17.4873 11.9562C18.7759 11.9562 19.8243 10.9949 19.8243 9.81338C19.8243 8.63182 18.7759 7.67059 17.4873 7.67059Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                  </svg>
                )}
              </ListItemIcon>
              <ListItemText
                className={
                  isMenuActive("logistics")
                    ? styles.selectedText
                    : styles.menuText
                }
                sx={{
                  display: { xs: "block", md: isDrawerOpen ? "block" : "none" },
                }}
              >
                <Typography className={styles.ListItemText_all}>
                  Logistics
                </Typography>
              </ListItemText>
              {isDrawerOpen &&
                (openMenu === "logistics" ? (
                  <ExpandLess className={styles.expandIcon} />
                ) : (
                  <ExpandMore className={styles.expandIcon} />
                ))}
            </ListItemButton>
            {isDrawerOpen ? (
              <Collapse
                in={openMenu === "logistics"}
                timeout="auto"
                unmountOnExit
              >
                <List
                  component="div"
                  disablePadding
                  className={styles.submenuList}
                >
                  {renderSubmenuItems("logistics")}
                </List>
              </Collapse>
            ) : (
              <Popover
                open={selectedMenu === "logistics"}
                anchorEl={anchorEl}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
                sx={{
                  "& .MuiPopover-paper": {
                    boxShadow: 1,
                    padding: "10px",
                    backgroundColor: "#fff",
                    marginLeft: "12px",
                  },
                }}
              >
                <List
                  component="div"
                  className={`${styles.submenuList} popoverSubmenuList`}
                >
                  {renderSubmenuItems("logistics")}
                </List>
              </Popover>
            )}
          </>
        )}

        {/* Report Section */}
        {shouldDisplayMenu("Report") && (
          <>
            <ListItemButton
              className={
                isMenuActive("Report")
                  ? styles.expandedSection
                  : styles.menuItem
              }
              onClick={(event) => {
                if (isDrawerOpen) {
                  handleMenuToggle("Report");
                } else {
                  handleMenuPopoverToggle(event, "Report");
                }
              }}
            >
              <ListItemIcon className={styles.iconContainer}>
                {/* {isMenuActive("Report") ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M20 13V11L18.3 10.4C18.1 9.8 17.9 9.2 17.6 8.6L18.4 7L17 5.6L15.4 6.4C14.9 6.1 14.3 5.8 13.6 5.7L13 4H11L10.4 5.7C9.8 5.9 9.2 6.1 8.7 6.4L7.1 5.6L5.6 7.1L6.4 8.7C6.1 9.2 5.9 9.8 5.7 10.4L4 11V13L5.7 13.6C5.9 14.2 6.1 14.8 6.4 15.4L5.6 17L7.1 18.4L8.7 17.6C9.2 17.9 9.8 18.1 10.4 18.3L11 20H13L13.6 18.3C14.2 18.1 14.8 17.9 15.4 17.6L17 18.4L18.4 17L17.6 15.4C17.9 14.8 18.1 14.2 18.3 13.6L20 13ZM12 15C10.3 15 9 13.7 9 12C9 10.3 10.3 9 12 9C13.7 9 15 10.3 15 12C15 13.7 13.7 15 12 15Z"
                      fill="#005FDB"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M20 13V11L18.3 10.4C18.1 9.8 17.9 9.2 17.6 8.6L18.4 7L17 5.6L15.4 6.4C14.9 6.1 14.3 5.8 13.6 5.7L13 4H11L10.4 5.7C9.8 5.9 9.2 6.1 8.7 6.4L7.1 5.6L5.6 7.1L6.4 8.7C6.1 9.2 5.9 9.8 5.7 10.4L4 11V13L5.7 13.6C5.9 14.2 6.1 14.8 6.4 15.4L5.6 17L7.1 18.4L8.7 17.6C9.2 17.9 9.8 18.1 10.4 18.3L11 20H13L13.6 18.3C14.2 18.1 14.8 17.9 15.4 17.6L17 18.4L18.4 17L17.6 15.4C17.9 14.8 18.1 14.2 18.3 13.6L20 13ZM12 15C10.3 15 9 13.7 9 12C9 10.3 10.3 9 12 9C13.7 9 15 10.3 15 12C15 13.7 13.7 15 12 15Z"
                      fill="#1B2B41"
                      fill-opacity="0.69"
                    />
                  </svg>
                )} */}
                <DescriptionIcon
                  sx={{
                    color: isMenuActive("Report") ? "#ffffff" : "rgba(27, 43, 65, 0.69)",
                    fontSize: 20,
                  }}
                />
              </ListItemIcon>
              <ListItemText
                className={
                  isMenuActive("Report") ? styles.selectedText : styles.menuText
                }
                sx={{
                  display: { xs: "block", md: isDrawerOpen ? "block" : "none" },
                }}
              >
                <Typography className={styles.ListItemText_all}>
                 Transaction Summary
                </Typography>
              </ListItemText>
              {isDrawerOpen &&
                (openMenu === "Report" ? (
                  <ExpandLess className={styles.expandIcon} />
                ) : (
                  <ExpandMore className={styles.expandIcon} />
                ))}
            </ListItemButton>
            {isDrawerOpen ? (
              <Collapse in={openMenu === "Report"} timeout="auto" unmountOnExit>
                <List
                  component="div"
                  disablePadding
                  className={styles.submenuList}
                >
                  {renderSubmenuItems("Report")}
                </List>
              </Collapse>
            ) : (
              <Popover
                open={selectedMenu === "Report"}
                anchorEl={anchorEl}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
                sx={{
                  "& .MuiPopover-paper": {
                    boxShadow: 1,
                    padding: "10px",
                    backgroundColor: "#fff",
                    marginLeft: "12px",
                  },
                }}
              >
                <List
                  component="div"
                  className={`${styles.submenuList} popoverSubmenuList`}
                >
                  {renderSubmenuItems("Report")}
                </List>
              </Popover>
            )}
          </>
        )}

        {/* admin Section */}
        {shouldDisplayMenu("admin") && (
          <>
            <ListItemButton
              className={
                isMenuActive("admin") ? styles.expandedSection : styles.menuItem
              }
              onClick={() =>
                handleSelect("Masters", "/masters/MastersMain/Masters")
              }
            >
              <ListItemIcon className={styles.iconContainer}>
                {selected === "Masters" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                      fill="#005FDB"
                    />
                    <path d="M8 10H16V12H8V10ZM8 14H14V16H8V14Z" fill="white" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                      fill="#ffffff"
                      fill-opacity="0.69"
                    />
                    <path
                      d="M8 10H16V12H8V10ZM8 14H14V16H8V14Z"
                      fill="white"
                      fill-opacity="0.69"
                    />
                  </svg>
                )}
              </ListItemIcon>
              <ListItemText
                className={
                  selected === "Masters" ? styles.selectedText : styles.menuText
                }
                sx={{
                  display: { xs: "block", md: isDrawerOpen ? "block" : "none" },
                }}
              >
                <Typography className={styles.ListItemText_all}>
                  Masters
                </Typography>
              </ListItemText>
            </ListItemButton>
          </>
        )}



        {/* Utility Section */}
        {shouldDisplayMenu("Utility") && (
          <>
            <ListItemButton
              className={
                isMenuActive("Utility")
                  ? styles.expandedSection
                  : styles.menuItem
              }
              onClick={(event) => {
                if (isDrawerOpen) {
                  handleMenuToggle("Utility");
                } else {
                  handleMenuPopoverToggle(event, "Utility");
                }
              }}
            >
              <ListItemIcon className={styles.iconContainer}>
                <SettingsIcon
                  sx={{
                    color: isMenuActive("Utility") ? "#005FDB" : "rgba(27, 43, 65, 0.69)",
                    fontSize: 20,
                  }}
                />
                {/* {isMenuActive("Utility") ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM12 16C10.34 16 9 14.66 9 13C9 11.34 10.34 10 12 10C13.66 10 15 11.34 15 13C15 14.66 13.66 16 12 16Z"
                      fill="#005FDB"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM12 16C10.34 16 9 14.66 9 13C9 11.34 10.34 10 12 10C13.66 10 15 11.34 15 13C15 14.66 13.66 16 12 16Z"
                      fill="#1B2B41"
                      fill-opacity="0.69"
                    />
                  </svg>
                )} */}
              </ListItemIcon>


              <ListItemText
                className={
                  isMenuActive("Utility")
                    ? styles.selectedText
                    : styles.menuText
                }
                sx={{
                  display: { xs: "block", md: isDrawerOpen ? "block" : "none" },
                }}
              >
                <Typography className={styles.ListItemText_all}>
                  Utility
                </Typography>
              </ListItemText>
              {isDrawerOpen &&
                (openMenu === "Utility" ? (
                  <ExpandLess className={styles.expandIcon} />
                ) : (
                  <ExpandMore className={styles.expandIcon} />
                ))}
            </ListItemButton>
            {isDrawerOpen ? (
              <Collapse
                in={openMenu === "Utility"}
                timeout="auto"
                unmountOnExit
              >
                <List
                  component="div"
                  disablePadding
                  className={styles.submenuList}
                >
                  {renderSubmenuItems("Utility")}
                </List>
              </Collapse>
            ) : (
              <Popover
                open={selectedMenu === "Utility"}
                anchorEl={anchorEl}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
                sx={{
                  "& .MuiPopover-paper": {
                    boxShadow: 1,
                    padding: "10px",
                    backgroundColor: "#fff",
                    marginLeft: "12px",
                  },
                }}
              >
                <List
                  component="div"
                  className={`${styles.submenuList} popoverSubmenuList`}
                >
                  {renderSubmenuItems("Utility")}
                </List>
              </Popover>
            )}
          </>
        )}

        {/* MR Section */}
        {shouldDisplayMenu("MrReport") && (
          <>
            <ListItemButton
              className={
                isMenuActive("MrReport")
                  ? styles.expandedSection
                  : styles.menuItem
              }
              onClick={(event) => {
                if (isDrawerOpen) {
                  handleMenuToggle("MrReport");
                } else {
                  handleMenuPopoverToggle(event, "MrReport");
                }
              }}
            >
              <ListItemIcon className={styles.iconContainer}>
                {/* {isMenuActive("MrReport") ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM12 16C10.34 16 9 14.66 9 13C9 11.34 10.34 10 12 10C13.66 10 15 11.34 15 13C15 14.66 13.66 16 12 16Z"
                      fill="#005FDB"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM12 16C10.34 16 9 14.66 9 13C9 11.34 10.34 10 12 10C13.66 10 15 11.34 15 13C15 14.66 13.66 16 12 16Z"
                      fill="#1B2B41"
                      fill-opacity="0.69"
                    />
                  </svg>
                )} */}

                 <DescriptionIcon
                  sx={{
                    color: isMenuActive("MrReport") ? "#005FDB" : "rgba(27, 43, 65, 0.69)",
                    fontSize: 20,
                  }}
                />
              </ListItemIcon>


              <ListItemText
                className={
                  isMenuActive("MrReport")
                    ? styles.selectedText
                    : styles.menuText
                }
                sx={{
                  display: { xs: "block", md: isDrawerOpen ? "block" : "none" },
                }}
              >
                <Typography className={styles.ListItemText_all}>
                  MR Report
                </Typography>
              </ListItemText>
              {isDrawerOpen &&
                (openMenu === "MrReport" ? (
                  <ExpandLess className={styles.expandIcon} />
                ) : (
                  <ExpandMore className={styles.expandIcon} />
                ))}
            </ListItemButton>
            {isDrawerOpen ? (
              <Collapse
                in={openMenu === "MrReport"}
                timeout="auto"
                unmountOnExit
              >
                <List
                  component="div"
                  disablePadding
                  className={styles.submenuList}
                >
                  {renderSubmenuItems("MrReport")}
                </List>
              </Collapse>
            ) : (
              <Popover
                open={selectedMenu === "MrReport"}
                anchorEl={anchorEl}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
                sx={{
                  "& .MuiPopover-paper": {
                    boxShadow: 1,
                    padding: "10px",
                    backgroundColor: "#fff",
                    marginLeft: "12px",
                  },
                }}
              >
                <List
                  component="div"
                  className={`${styles.submenuList} popoverSubmenuList`}
                >
                  {renderSubmenuItems("MrReport")}
                </List>
              </Popover>
            )}
          </>
        )}



           {shouldDisplayMenu("customerHolding") && (
          <>
            <ListItemButton
              className={
                isMenuActive("customerHolding")
                  ? styles.expandedSection
                  : styles.menuItem
              }
              onClick={(event) => {
                if (isDrawerOpen) {
                  handleMenuToggle("customerHolding");
                } else {
                  handleMenuPopoverToggle(event, "customerHolding");
                }
              }}
            >
              <ListItemIcon className={styles.iconContainer}>
                {/* {isMenuActive("productionreport") ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM12 16C10.34 16 9 14.66 9 13C9 11.34 10.34 10 12 10C13.66 10 15 11.34 15 13C15 14.66 13.66 16 12 16Z"
                      fill="#005FDB"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    class="bi bi-newspaper"

                  >
                    <path
                      d="M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM12 16C10.34 16 9 14.66 9 13C9 11.34 10.34 10 12 10C13.66 10 15 11.34 15 13C15 14.66 13.66 16 12 16Z"
                      fill="#1B2B41"
                      fill-opacity="0.69"
                    />
                  </svg>
                )} */}
                <DescriptionIcon
                  sx={{
                    color: isMenuActive("customerHolding") ? "#005FDB" : "rgba(27, 43, 65, 0.69)",
                    fontSize: 20,
                  }}
                />
              </ListItemIcon>


              <ListItemText
                className={
                  isMenuActive("customerHolding")
                    ? styles.selectedText
                    : styles.menuText
                }
                sx={{
                  display: { xs: "block", md: isDrawerOpen ? "block" : "none" },
                }}
              >
                <Typography className={styles.ListItemText_all}>
            Customer Holding 
                </Typography>
              </ListItemText>
              {isDrawerOpen &&
                (openMenu === "customerHolding" ? (
                  <ExpandLess className={styles.expandIcon} />
                ) : (
                  <ExpandMore className={styles.expandIcon} />
                ))}
            </ListItemButton>
            {isDrawerOpen ? (
              <Collapse
                in={openMenu === "customerHolding"}
                timeout="auto"
                unmountOnExit
              >
                <List
                  component="div"
                  disablePadding
                  className={styles.submenuList}
                >
                  {renderSubmenuItems("customerHolding")}
                </List>
              </Collapse>
            ) : (
              <Popover
                open={selectedMenu === "customerHolding"}
                anchorEl={anchorEl}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
                sx={{
                  "& .MuiPopover-paper": {
                    boxShadow: 1,
                    padding: "10px",
                    backgroundColor: "#fff",
                    marginLeft: "12px",
                  },
                }}
              >
                <List
                  component="div"
                  className={`${styles.submenuList} popoverSubmenuList`}
                >
                  {renderSubmenuItems("customerHolding")}
                </List>
              </Popover>
            )}
          </>
        )}






        {/* productionreport Section */}
        {shouldDisplayMenu("productionreport") && (
          <>
            <ListItemButton
              className={
                isMenuActive("productionreport")
                  ? styles.expandedSection
                  : styles.menuItem
              }
              onClick={(event) => {
                if (isDrawerOpen) {
                  handleMenuToggle("productionreport");
                } else {
                  handleMenuPopoverToggle(event, "productionreport");
                }
              }}
            >
              <ListItemIcon className={styles.iconContainer}>
                {/* {isMenuActive("productionreport") ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM12 16C10.34 16 9 14.66 9 13C9 11.34 10.34 10 12 10C13.66 10 15 11.34 15 13C15 14.66 13.66 16 12 16Z"
                      fill="#005FDB"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    class="bi bi-newspaper"

                  >
                    <path
                      d="M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM12 16C10.34 16 9 14.66 9 13C9 11.34 10.34 10 12 10C13.66 10 15 11.34 15 13C15 14.66 13.66 16 12 16Z"
                      fill="#1B2B41"
                      fill-opacity="0.69"
                    />
                  </svg>
                )} */}
                <DescriptionIcon
                  sx={{
                    color: isMenuActive("productionreport") ? "#005FDB" : "rgba(27, 43, 65, 0.69)",
                    fontSize: 20,
                  }}
                />
              </ListItemIcon>


              <ListItemText
                className={
                  isMenuActive("productionreport")
                    ? styles.selectedText
                    : styles.menuText
                }
                sx={{
                  display: { xs: "block", md: isDrawerOpen ? "block" : "none" },
                }}
              >
                <Typography className={styles.ListItemText_all}>
                  Production
                </Typography>
              </ListItemText>
              {isDrawerOpen &&
                (openMenu === "productionreport" ? (
                  <ExpandLess className={styles.expandIcon} />
                ) : (
                  <ExpandMore className={styles.expandIcon} />
                ))}
            </ListItemButton>
            {isDrawerOpen ? (
              <Collapse
                in={openMenu === "productionreport"}
                timeout="auto"
                unmountOnExit
              >
                <List
                  component="div"
                  disablePadding
                  className={styles.submenuList}
                >
                  {renderSubmenuItems("productionreport")}
                </List>
              </Collapse>
            ) : (
              <Popover
                open={selectedMenu === "productionreport"}
                anchorEl={anchorEl}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
                sx={{
                  "& .MuiPopover-paper": {
                    boxShadow: 1,
                    padding: "10px",
                    backgroundColor: "#fff",
                    marginLeft: "12px",
                  },
                }}
              >
                <List
                  component="div"
                  className={`${styles.submenuList} popoverSubmenuList`}
                >
                  {renderSubmenuItems("productionreport")}
                </List>
              </Popover>
            )}
          </>
        )}






        {/* Distribution Section */}
        {shouldDisplayMenu("Distribution") && (
          <>
            <ListItemButton
              className={
                isMenuActive("Distribution")
                  ? styles.expandedSection
                  : styles.menuItem
              }
              onClick={(event) => {
                if (isDrawerOpen) {
                  handleMenuToggle("Distribution");
                } else {
                  handleMenuPopoverToggle(event, "Distribution");
                }
              }}
            >
              <ListItemIcon className={styles.iconContainer}>
                {/* {isMenuActive("Distribution") ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM12 16C10.34 16 9 14.66 9 13C9 11.34 10.34 10 12 10C13.66 10 15 11.34 15 13C15 14.66 13.66 16 12 16Z"
                      fill="#005FDB"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    class="bi bi-newspaper"

                  >
                    <path
                      d="M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM12 16C10.34 16 9 14.66 9 13C9 11.34 10.34 10 12 10C13.66 10 15 11.34 15 13C15 14.66 13.66 16 12 16Z"
                      fill="#1B2B41"
                      fill-opacity="0.69"
                    />
                  </svg>
                )} */}
                <DescriptionIcon
                  sx={{
                    color: isMenuActive("Distribution") ? "#005FDB" : "rgba(27, 43, 65, 0.69)",
                    fontSize: 20,
                  }}
                />
              </ListItemIcon>


              <ListItemText
                className={
                  isMenuActive("production")
                    ? styles.selectedText
                    : styles.menuText
                }
                sx={{
                  display: { xs: "block", md: isDrawerOpen ? "block" : "none" },
                }}
              >
                <Typography className={styles.ListItemText_all}>
                  Distribution
                </Typography>
              </ListItemText>
              {isDrawerOpen &&
                (openMenu === "Distribution" ? (
                  <ExpandLess className={styles.expandIcon} />
                ) : (
                  <ExpandMore className={styles.expandIcon} />
                ))}
            </ListItemButton>
            {isDrawerOpen ? (
              <Collapse
                in={openMenu === "Distribution"}
                timeout="auto"
                unmountOnExit
              >
                <List
                  component="div"
                  disablePadding
                  className={styles.submenuList}
                >
                  {renderSubmenuItems("Distribution")}
                </List>
              </Collapse>
            ) : (
              <Popover
                open={selectedMenu === "Distribution"}
                anchorEl={anchorEl}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
                sx={{
                  "& .MuiPopover-paper": {
                    boxShadow: 1,
                    padding: "10px",
                    backgroundColor: "#fff",
                    marginLeft: "12px",
                  },
                }}
              >
                <List
                  component="div"
                  className={`${styles.submenuList} popoverSubmenuList`}
                >
                  {renderSubmenuItems("Distribution")}
                </List>
              </Popover>
            )}
          </>
        )}

        {/* distribution Section */}
        {shouldDisplayMenu("Inventory") && (
          <>
            <ListItemButton
              className={
                isMenuActive("Inventory")
                  ? styles.expandedSection
                  : styles.menuItem
              }
              onClick={(event) => {
                if (isDrawerOpen) {
                  handleMenuToggle("Inventory");
                } else {
                  handleMenuPopoverToggle(event, "Inventory");
                }
              }}
            >
              <ListItemIcon className={styles.iconContainer}>
                {/* {isMenuActive("Inventory") ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM12 16C10.34 16 9 14.66 9 13C9 11.34 10.34 10 12 10C13.66 10 15 11.34 15 13C15 14.66 13.66 16 12 16Z"
                      fill="#005FDB"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    class="bi bi-newspaper"

                  >
                    <path
                      d="M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3ZM12 16C10.34 16 9 14.66 9 13C9 11.34 10.34 10 12 10C13.66 10 15 11.34 15 13C15 14.66 13.66 16 12 16Z"
                      fill="#1B2B41"
                      fill-opacity="0.69"
                    />
                  </svg>
                )} */}
                <DescriptionIcon
                  sx={{
                    color: isMenuActive("Inventory") ? "#005FDB" : "rgba(27, 43, 65, 0.69)",
                    fontSize: 20,
                  }}
                />
              </ListItemIcon>


              <ListItemText
                className={
                  isMenuActive("Inventory")
                    ? styles.selectedText
                    : styles.menuText
                }
                sx={{
                  display: { xs: "block", md: isDrawerOpen ? "block" : "none" },
                }}
              >
                <Typography className={styles.ListItemText_all}>
                  Inventory
                </Typography>
              </ListItemText>
              {isDrawerOpen &&
                (openMenu === "Inventory" ? (
                  <ExpandLess className={styles.expandIcon} />
                ) : (
                  <ExpandMore className={styles.expandIcon} />
                ))}
            </ListItemButton>
            {isDrawerOpen ? (
              <Collapse
                in={openMenu === "Inventory"}
                timeout="auto"
                unmountOnExit
              >
                <List
                  component="div"
                  disablePadding
                  className={styles.submenuList}
                >
                  {renderSubmenuItems("Inventory")}
                </List>
              </Collapse>
            ) : (
              <Popover
                open={selectedMenu === "Inventory"}
                anchorEl={anchorEl}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
                sx={{
                  "& .MuiPopover-paper": {
                    boxShadow: 1,
                    padding: "10px",
                    backgroundColor: "#fff",
                    marginLeft: "12px",
                  },
                }}
              >
                <List
                  component="div"
                  className={`${styles.submenuList} popoverSubmenuList`}
                >
                  {renderSubmenuItems("Inventory")}
                </List>
              </Popover>
            )}
          </>
        )}
      </List>
    </Box>
  );
  return (
    <Box sx={{ padding: "0px !important", margin: "0px !important" }}>
      {/* Mini Drawer for tablet and desktop */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "none", md: "block" },
          width: isDrawerOpen
            ? { md: drawerWidth.md, lg: drawerWidth.lg, xl: drawerWidth.xl }
            : {
              md: miniDrawerWidth.md,
              lg: miniDrawerWidth.lg,
              xl: miniDrawerWidth.xl,
            },
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: isDrawerOpen
              ? { md: drawerWidth.md, lg: drawerWidth.lg, xl: drawerWidth.xl }
              : {
                md: miniDrawerWidth.md,
                lg: miniDrawerWidth.lg,
                xl: miniDrawerWidth.xl,
              },
            boxSizing: "border-box",
            backgroundColor: "#ffffff",
            borderRight: "1px solid #f0f0f0",
            transition: (theme) =>
              theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
              }),
            overflowX: "hidden",
            overflowY: "auto",
            "&::-webkit-scrollbar": { display: "none" },
            scrollbarWidth: "none",
            "-ms-overflow-style": "none",
          },
        }}
        open
      >
        {drawerContent}
      </Drawer>

      {/* Temporary Drawer for mobile */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", sm: "block", md: "none" },
          "& .MuiDrawer-paper": {
            width: { xs: drawerWidth.xs, sm: drawerWidth.sm },
            backgroundColor: "#ffffff",
            borderRight: "1px solid #f0f0f0",
            boxSizing: "border-box",
          },
        }}
      >
        {drawerContent}
      </Drawer>
    </Box>
  );
};
export default MiniMenuBar;
